export const idReg1 = /(KE|TDR)\d{3}/;
export const emailReg = /[a-z]+(@kadickintegrated.com)/i;
export const firstnameReg = /^[a-z]+/i;
export const surnameReg = /[a-z]+$/i;
export const api = process.env.REACT_APP_API_URL || 'http://localhost:3002/';